export default "__VITE_ASSET__BqxsxVQk__"